module.exports = __webpack_public_path__ + "media/components/src/assets/images/gallery_5-e9b8e4a5003aef8e9c52eb08fa4e33ca.jpg";